import { render, staticRenderFns } from "./TodoControl.vue?vue&type=template&id=19354e0e&"
import script from "./TodoControl.vue?vue&type=script&lang=ts&"
export * from "./TodoControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports